import React from 'react';
import PropTypes from 'prop-types';
import DS_Header from 'mui/components/elements/DS_Header';
import DS_BottomCaptionCard from 'mui/components/elements/DS_BottomCaptionCard/DS_BottomCaptionCard';
import DS_MaxWidthLayout from '../../elements/DS_MaxWidthLayout';
import { BottomCaptionCardsContainer } from '../../elements/DS_BottomCaptionCard';
import { StyledSection } from './DS_ProblemsStyles';

const DS_Problems = data => {
  const { headline, headerLink, problemCards } = data;

  return (
    <StyledSection>
      <DS_MaxWidthLayout>
        <DS_Header headline={headline} link={headerLink} />
        <BottomCaptionCardsContainer>
          {problemCards?.map(problemCard => (
            <DS_BottomCaptionCard key={problemCard.id} data={problemCard}></DS_BottomCaptionCard>
          ))}
        </BottomCaptionCardsContainer>
      </DS_MaxWidthLayout>
    </StyledSection>
  );
};

export default DS_Problems;

DS_Problems.prototype = {
  data: PropTypes.shape({
    headline: PropTypes.string,
    headerLink: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    problemCards: PropTypes.array,
  }),
};
